import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import ServiceService from 'services/ServiceService';
import HintText from 'components/labels/HintText';
import ButtonStatus from 'components/buttons/ButtonStatus';
import { capatilizeFirst } from 'commons/utils/stringUtils';
import ServiceFormModal from 'views/services/ServiceFormModal';
import FormikDownshift from './FormikDownshift';
import { LinearProgress } from '@mui/material';

// COMPONENT
function ServiceDownshift({ getSuggestionLabel, suggestionsNode, onAdd, hideAdd, ...others }) {
  const refNewDefaultName = useRef('');
  const [formModalOpen, setFormModalOpen] = useState(false);

  const handleSearchTerm = React.useCallback((inputValue) => {
    return ServiceService.search(inputValue).then((data) => {
      return data;
    });
  }, []);

  const areItemsDifferentChecker = (prevItem, item) => {
    return (
      (prevItem == null && item != null) ||
      (prevItem != null && item == null) ||
      (prevItem != null && item != null && prevItem.id !== item.id)
    );
  };

  const handleCloseForm = () => {
    setFormModalOpen(false);
  };

  const handleCreateCustomer = (newCreatedItem) => {
    setFormModalOpen(false);
    onAdd(newCreatedItem);
  };

  return (
    <>
      {formModalOpen && (
        <ServiceFormModal
          open={formModalOpen}
          defaultName={refNewDefaultName.current}
          onClose={handleCloseForm}
          onCreateCallback={handleCreateCustomer}
        />
      )}
      <FormikDownshift
        onChangeSearchTerm={handleSearchTerm}
        getSuggestionLabel={getSuggestionLabel}
        areItemsDifferentChecker={areItemsDifferentChecker}
        placeholder="Digite para buscar..."
        noOptionsNode={(mySearchTerm, mySelectedItem, myCloseMenu, myIsLoading, mySuggestionsIsNull) => {
          return (
            <div>
              <div>
                <HintText component="div">
                  {myIsLoading ? 'Buscando...' : ''}
                  {myIsLoading && <LinearProgress />}
                  {!myIsLoading && mySearchTerm.trim().length === 0 ? 'Digite para buscar...' : ''}
                  {!myIsLoading && !mySuggestionsIsNull && mySearchTerm.trim().length > 0
                    ? 'Nenhum resultado encontrado.'
                    : ''}
                </HintText>
              </div>
              {suggestionsNode && mySearchTerm.trim().length === 0 && mySelectedItem == null && (
                <>{suggestionsNode(mySearchTerm, mySelectedItem, myCloseMenu)}</>
              )}

              <div style={{ marginTop: '10px' }}>
                {!hideAdd && !myIsLoading && (
                  <ButtonStatus
                    status="success"
                    size="small"
                    onClick={() => {
                      refNewDefaultName.current = capatilizeFirst(mySearchTerm);
                      setFormModalOpen(true);
                    }}
                    variant="contained"
                    fullWidth
                  >
                    Adicionar serviço
                  </ButtonStatus>
                )}
              </div>
            </div>
          );
        }}
        {...others}
      />
    </>
  );
}

ServiceDownshift.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
ServiceDownshift.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default ServiceDownshift;
